<div class="wrapper">
	<app-advanced-gridview
		[dataSource]="dataSource"
		[size]="size"
		[model]="filteredTableModel"
		[sortEnabled]="true"
		[menuItems]="menuItems"
		[contextualMenu]="true"
		(menuClicked)="onAction($event)"
		(rowClicked)="onSelection($event)"
		(itemsSorted)="onItemsSorted($event)"></app-advanced-gridview>
</div>
